import React from 'react';
import { useTranslation } from 'react-i18next';
import './NotificationsHeader.css';

function NotificationsHeader({ unreadCount, onMarkAllAsRead }) {
  const { t } = useTranslation('notifications');

  if (unreadCount === 0) {
    return null;
  }

  return (
    <div className="notifications-header">
      <span className="unread-count">
        {unreadCount} {t('notifications.unread') || 'nieprzeczytanych'}
      </span>
      <button 
        className="mark-all-read-btn"
        onClick={onMarkAllAsRead}
      >
        {t('notifications.mark_all_read') || 'Oznacz wszystkie jako przeczytane'}
      </button>
    </div>
  );
}

export default NotificationsHeader;
